import router from "@/plugins/router";
import { authApi } from "@/services/api/AuthApi";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import {
  state as authState,
  getters as authGetters,
  mutations as authMutations,
  actions as authActions,
} from "./authStore";
import {
  state as notificationState,
  getters as notificationGetters,
  mutations as notificationMutations,
  actions as notificationActions,
} from "./notificationStore";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ...authState,
    ...notificationState,
  },
  mutations: {
    ...authMutations,
    ...notificationMutations,
  },
  getters: {
    ...authGetters,
    ...notificationGetters,
  },
  actions: {
    ...authActions,
    ...notificationActions,
  },
  plugins: [createPersistedState()],
});
